import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 40px;
`;

const LeftContent = styled.div`
  align-items: center;
  display: flex;
  flex: 2;
  flex-direction: column;
  gap: 64px;
`;

const RightContent = styled.div`
  align-items: center;
  background: var(--color-bg-weaker);
  border-radius: var(--size-border-radius-md);
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 24px;
  padding: 24px 40px;
`;

const QrWrapper = styled.div`
  align-self: center;
  display: flex;
`;

const SupportLink = styled.a`
  color: var(--color-fg-weakest);
  text-decoration: underline;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
`;

const TitleWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const ButtonGroup = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
`;

const OrderBodyFooterText = styled.p`
  color: var(--color-fg-weaker);
`;

const StatusWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const RightBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  height: 540px;
`;

export {
  ButtonGroup,
  Content,
  LeftContent,
  OrderBodyFooterText,
  QrWrapper,
  RightBody,
  RightContent,
  StatusWrapper,
  SupportLink,
  TitleWrapper,
  Wrapper
};
